// import Person from './scripts/Person';
// import ExampleReactComponent from './scripts/ExampleReactComponent';
// import React from 'react';
// import ReactDOM from 'react-dom';
import axios from 'axios';
import $ from 'jquery';
// const person1 = new Person("Brad")
// if (document.querySelector("#render-react-example-here")) {
// 	ReactDOM.render(<ExampleReactComponent />, document.querySelector("#render-react-example-here"))
// }
window.j = $;

if ( document.getElementById( 'speakerModal' ) ) {
	const myModalEl = document.getElementById( 'speakerModal' );
	myModalEl.addEventListener( 'show.bs.modal', ( event ) => {
		const $modalBody = $( '#speakerModal .modal-body' );
		const speakerId = event.relatedTarget.dataset.speakerId;
		let isLoading = true;

		const loadingPlaceholder = $( '.speaker-modal-placeholder-content' ).html();

		( async function() {
			const res = await axios.get( `/wp-json/api/v1/get-speaker-detail?speaker_id=${ speakerId }` );
			isLoading = false;
			if ( ! isLoading ) {
				$modalBody.html( res.data );
			}
		}() );

		if ( isLoading ) {
			$modalBody.html( loadingPlaceholder );
			$modalBody.removeClass( 'd-none' );
		}
	} );
}
